
import React, { Component } from 'react';
import { formatCSS } from '../cssHelper';

import loginFormPNG from '../../assets/images/loginform_v2.png';
import Button from './button';
import { API_ENDPOINT, TINYMCE_SWITCH } from '../../constants';

/**
* Component for html field
* @author   Milan Stanojevic
*/
class ConditionalLinks extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        const buttonText = 'External Link'.translate(this.props.lang);

        const buttonElement = <Button
            selectedClinic={this.props.selectedClinic}
            selectedGroup={this.props.selectedGroup}
            props={this.props.props}
            style={this.props.style}
            hidTinymce={true}
            onChange={(text) => {
                console.log('text', text);
                // this.props.changeElement(item.i, 'value', text)
            }}
            value={buttonText}
        />;
        const buttonComponent =
            TINYMCE_SWITCH && false ?
                this.props.showTinymceEditor[this.props?.item?.i] ?
                    buttonElement
                    :
                    <div style={formatCSS(this.props.style)} >
                        {
                            this.props.props && this.props.props.icon && this.props.props.icon != null && this.props.props.icon != 'null' ?
                                <img src={API_ENDPOINT + this.props.props.icon} style={iconStyle} />
                                :
                                null
                        }
                        <div dangerouslySetInnerHTML={{ __html: buttonText ? buttonText : '' }} onChange={() => { }}></div>
                    </div>
                :
                buttonElement;
        return (
            <div style={{ ...formatCSS(this.props.containerStyle), position: 'relative' }}>
                <div style={{ marginBottom: 10, fontSize: 18, fontWeight: 'bold' }}>
                    {'Chapter'.translate(this.props.lang)}
                </div>
                {buttonElement}
                {buttonElement}
                {buttonElement}
                {buttonElement}

            </div>




        );
    }
}

export default ConditionalLinks;